import React, { Fragment, useState } from 'react'
import axios from 'axios'
import { useQueryClient } from 'react-query'
import useFilters from '../../../hooks/useFilters'
import { BoxTable } from '../../molecules/BoxTable'
import { AreasTable } from './AreasTable'
import useInstitution from '../../../hooks/useInstitution'
import DialogErrorMessage from './DialogErrorMessage'
import PropTypes from 'prop-types'

const sortOptions = [
  {
    value: 'name asc',
    label: 'Nombre (A-Z)'
  },
  {
    value: 'name desc',
    label: 'Nombre (Z-A)'
  },
  {
    value: 'created_at desc',
    label: 'Más recientes primero'
  },
  {
    value: 'created_at asc',
    label: 'Más antiguos primero'
  }
]

export const Areas = ({ paramsLinkBranchOffice, onUserSelect }) => {
  const [paramsDeleteDialog, setParamsDeleteDialog] = useState()
  const urlFetch = `/admin/v1/areas.json`
  const { onFilter, initialFilters, results: areas } = useFilters(urlFetch, { sort: 'name asc' })
  const queryClient = useQueryClient()
  const { querySameInstitution } = useInstitution()
  const handleDestroy = async area => {
    if (window.confirm(`¿Estás seguro que deseas eliminar el área ${area.name}?`)) {
      try {
        await axios.delete(`/admin/v1/areas/${area.id}.json`)
        queryClient.invalidateQueries(urlFetch)
      } catch (error) {
        if (error.response.data.dialog) {
          setParamsDeleteDialog(error.response.data.dialog[0])
        } else {
          window.alert(error.response.data.message)
        }
      }
    }
  }

  const handleUserSelect = id => {
    onUserSelect(null, 'userTab')
  }

  return (
    <Fragment>
      <DialogErrorMessage onClose={() => setParamsDeleteDialog()} params={paramsDeleteDialog} />
      <BoxTable
        id="areas"
        initialFilters={initialFilters}
        onFilter={onFilter}
        buttons={
          querySameInstitution && [
            {
              name: '+ Crear área',
              link: `/areas/crear?${paramsLinkBranchOffice}`,
              variant: 'secondary',
              className: 'md:w-56'
            }
          ]
        }
        displayTotal
        displaySort
        sortOptions={sortOptions}
        values={areas}
        searchPlaceholder="Buscar por nombre"
      >
        <AreasTable
          internalAreas={areas.data}
          onDestroy={handleDestroy}
          urlFetch={urlFetch}
          onUserSelect={handleUserSelect}
        />
      </BoxTable>
    </Fragment>
  )
}

Areas.propTypes = {
  paramsLinkBranchOffice: PropTypes.string,
  onUserSelect: PropTypes.func
}
